const initialState = {
  rules: [],
  taskTemplates: [],
  labels: [],
  isLoading: false,
  error: false,
  errorMessage: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'BEGIN_GET_TASK_ROUTING_RULES':
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: '',
      };
    case 'FINISH_GET_TASK_ROUTING_RULES':
      return {
        ...state,
        isLoading: false,
        rules: action.payload.data.task_routing_rules || [],
      };
    case 'FAILED_GET_TASK_ROUTING_RULES':
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload?.response?.data?.error || 'Failed to load routing rules',
      };
    case 'BEGIN_CREATE_TASK_ROUTING_RULE':
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: '',
      };
    case 'FINISH_CREATE_TASK_ROUTING_RULE':
      return {
        ...state,
        isLoading: false,
        rules: [...state.rules, action.payload.data.task_routing_rule],
      };
    case 'FAILED_CREATE_TASK_ROUTING_RULE':
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload?.response?.data?.error || 'Failed to create routing rule',
      };
    case 'BEGIN_UPDATE_TASK_ROUTING_RULE':
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: '',
      };
    case 'FINISH_UPDATE_TASK_ROUTING_RULE': {
      const updatedRule = action.payload.data.task_routing_rule;
      return {
        ...state,
        isLoading: false,
        rules: state.rules.map((rule) =>
          rule.id === updatedRule.id ? updatedRule : rule
        ),
      };
    }
    case 'FAILED_UPDATE_TASK_ROUTING_RULE':
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload?.response?.data?.error || 'Failed to update routing rule',
      };
    case 'BEGIN_DELETE_TASK_ROUTING_RULE':
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: '',
      };
    case 'FINISH_DELETE_TASK_ROUTING_RULE':
      return {
        ...state,
        isLoading: false,
        // Note: We don't have the deleted ID in the action payload from DELETE response,
        // so the component refetches the rules list after successful delete.
        // This ensures UI stays in sync even if local state removal isn't possible.
      };
    case 'FAILED_DELETE_TASK_ROUTING_RULE':
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload?.response?.data?.error || 'Failed to delete routing rule',
      };
    case 'BEGIN_REORDER_TASK_ROUTING_RULES':
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: '',
      };
    case 'FINISH_REORDER_TASK_ROUTING_RULES':
      return {
        ...state,
        isLoading: false,
      };
    case 'FAILED_REORDER_TASK_ROUTING_RULES':
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: action.payload?.response?.data?.error || 'Failed to reorder routing rules',
      };
    case 'FINISH_GET_ROUTING_RULE_TEMPLATES':
      return {
        ...state,
        taskTemplates: action.payload.data.ema_task_templates || [],
      };
    case 'FINISH_GET_ROUTING_RULE_LABELS':
      return {
        ...state,
        labels: action.payload.data.labels || [],
      };
    default:
      return state;
  }
};
